/* eslint-disable no-unused-expressions */
import logger from '../../utils/logger';
import { displayInAppError } from '../../utils/toast/Toast';
import {
  getCurrency,
  getCountryCode,
  getOfferCode,
  requiredCompanyName
} from './utils/checker';
import getBindingTemplate from './utils/getBindingTemplate';
/**
 * @function convertToCommandsArrayWithoutHeader
 * @description Convertir un fichier json obtenu sans header en un fichier de commande
 * sympl
 * @param {Object[]} jsonFile - Fichier json
 * @param {string} format - Format sympl du fichier importer
 * @returns {Object[]} Fichier de commande au format sympl
 */

const convertToCommandsArrayWithoutHeader = (jsonFile, format) => {
  let symplFormatCommands = [];
  let unknowDeliveryOffer = [];
  try {
    const template = getBindingTemplate(format);

    const offerCodeHelper = offerCode => {
      const code = getOfferCode(offerCode);
      if (code) {
        return code.value;
      }
      unknowDeliveryOffer.findIndex(offer => offer.name === offerCode) === -1
        ? unknowDeliveryOffer.push({ name: offerCode, bindingValue: '' })
        : '';
      return null;
    };

    jsonFile.forEach(command => {
      const index = symplFormatCommands.findIndex(
        symplFormatCommand =>
          symplFormatCommand.externalReference ===
          command[template.externalReference.columnNumber]
      );
      const item = {
        externalReference: command[template.productReference.columnNumber],
        ean13: command[template.ean13.columnNumber],
        quantity: command[template.quantity.columnNumber],
        description: command[template.productDescription.columnNumber],
        size: command[template.size.columnNumber],
        color: command[template.color.columnNumber]
      };

      const customsDeclarations = {
        currency: command[template.currency.columnNumber],
        declaredValue: command[template.unitValue.columnNumber],
        objectType: command[template.productDescription.columnNumber],
        quantity: command[template.quantity.columnNumber]
      };

      if (index !== -1) {
        symplFormatCommands[index].items.push(item);
        symplFormatCommands[index].customsDeclarations.push(
          customsDeclarations
        );
      } else {
        symplFormatCommands.push({
          externalReference: command[template.externalReference.columnNumber],
          insuranceAmount: command[template.insuranceAmount.columnNumber]
            ? +command[template.insuranceAmount.columnNumber]
            : '300',
          deliveryType: requiredCompanyName(
            command[template.offerCode.columnNumber]
          )
            ? 'company'
            : 'residential',
          offerCode: offerCodeHelper(command[template.offerCode.columnNumber]),
          initialOfferCode: command[template.offerCode.columnNumber],
          shipmentCategory: 3,
          recipient: {
            email: command[template.recipientEmail.columnNumber],
            phoneNumber: command[template.recipientPhoneNumber.columnNumber],
            firstname: command[template.firstname.columnNumber],
            lastname: command[template.lastname.columnNumber],
            companyName: command[template.companyName.columnNumber]
          },
          recipientAddress: {
            street: command[template.street.columnNumber],
            street2: command[template.street2.columnNumber],
            complement: command[template.complement.columnNumber],
            postalCode: command[template.postalCode.columnNumber]
              .toString()
              .replace(/^'/, ''),
            state: command[template.state.columnNumber],
            city: command[template.city.columnNumber],
            countryCode: getCountryCode(
              command[template.countryCode.columnNumber]
            )
          },
          appContext: {
            appCode: 'WEBAPP_V2',
            domain: ''
          },
          customsDeclarations: [
            {
              currency: getCurrency(command[template.currency.columnNumber]),
              declaredValue: command[template.unitValue.columnNumber],
              objectType: command[template.productDescription.columnNumber],
              quantity: command[template.quantity.columnNumber]
            }
          ],
          items: [
            {
              externalReference:
                command[template.productReference.columnNumber],
              ean13: command[template.ean13.columnNumber],
              quantity: command[template.quantity.columnNumber],
              description: command[template.productDescription.columnNumber],
              size: command[template.size.columnNumber],
              color: command[template.color.columnNumber]
            }
          ],
          errorsItem: [],
          warnings: []
        });
      }
    });
  } catch (e) {
    symplFormatCommands = [];
    unknowDeliveryOffer = [];
    displayInAppError(
      'Erreur lors de la lecture du fichier, veuillez vérifier son format'
    );
    logger(e);
  }
  return {
    symplFormatCommands,
    unknowDeliveryOffer
  };
};

export default convertToCommandsArrayWithoutHeader;
